// extracted by mini-css-extract-plugin
export default {"root":"RatingSelect_root__tD8pD"};